export default __webpack_public_path__ + "static/media/retrievingresults.760e12d4.png";